import { render, staticRenderFns } from "./Subjects.vue?vue&type=template&id=74cb1b15&"
import script from "./Subjects.vue?vue&type=script&lang=ts&"
export * from "./Subjects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports